import script from "./ExistingSurveysModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExistingSurveysModal.vue?vue&type=script&setup=true&lang=js"

import "./ExistingSurveysModal.vue?vue&type=style&index=0&id=134cc52a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134cc52a"]])

export default __exports__